// App-wide enums and option/constant data. Domain-specific constants live in their
// own module here (e.g. building.js, support.js). Utility *functions* live in
// shared/utils.

export const SUPPORT_SOURCES = {
  user: 'user',
  system: 'system',
};

export const MODULES = {
  admin: 'User',
  building: 'Building',
  coupon: 'Coupon',
  networking: 'Networking',
  support: 'Ticket',
  tenant: 'Tenant',
  voucher: 'Voucher',
};

export const RELOCATE_MODES = {
  merge: 'merge',
  move: 'move',
};

export const VARIANTS = {
  danger: 'danger',
  dark: 'dark',
  info: 'info',
  light: 'light',
  link: 'link',
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  warning: 'warning',

  outlineSecondary: 'outline-secondary',
  outlineSuccess: 'outline-success',

  //   MUI variants
  contained: 'contained',
  outlined: 'outlined',
};

export const BUTTON_COLORS = {
  error: 'error',
  info: 'info',
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  warning: 'warning',
  neutral: 'neutral',
};

export const FILE_SIZES = {
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024,
};

export const VLAN_DEFAULTS = {
  defaultVlanStart: 2000,
  defaultVlanEnd: 3099,
};

export const VOUCHER_TYPES = {
  billable: {
    id: 'billable',
    label: 'Billable',
  },
  free: {
    id: 'free',
    label: 'Non-Billable',
  },
  testing: {
    id: 'testing',
    label: 'Building Testing',
  },
};

export const VOUCHER_RULES = {
  property: {
    id: 'property',
    label: 'Building',
  },
  complex: {
    id: 'complex',
    label: 'Complex',
  },
};

export const RADIUS_PERMISSION_GROUPS = [
  {
    label: 'Complex Router Admin',
    groupname: 'complex-router-admin',
  },
  {
    label: 'VTR Admin',
    groupname: 'vtr-admin',
  },
  {
    label: 'VTR Read Only',
    groupname: 'vtr-readonly',
  },
  {
    label: 'Complex Router Read Only',
    groupname: 'complex-router-read-only',
  },
];

export const FILTER_DISPLAY_TYPE = {
  control: 'control',
  group: 'group',
};
